<script lang="ts" setup></script>

<template>
  <svg fill="none" height="501" viewBox="0 0 501 501" width="501" xmlns="http://www.w3.org/2000/svg">
    <!-- Outer circle with currentColor fill -->
    <circle cx="250.5" cy="250.5" fill="currentColor" r="242.5" stroke="#0A2538" stroke-width="16" />

    <!-- Inner circle with drop shadow -->
    <g filter="url(#dropShadow)">
      <circle cx="250" cy="250" fill="#fff" r="140" />
      <circle cx="250" cy="250" r="132" stroke="#0A2538" stroke-width="16" />
    </g>

    <defs>
      <filter
        id="dropShadow"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
        height="324"
        width="324"
        x="88"
        y="101"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 127 0"
        />
        <feMorphology in="SourceAlpha" operator="erode" radius="5" result="drop1" />
        <feOffset dy="13" />
        <feGaussianBlur stdDeviation="13.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.196
                0 0 0 0 0.196
                0 0 0 0 0.365
                0 0 0 0.25 0"
        />
        <feBlend in2="BackgroundImageFix" mode="normal" result="dropShadow1" />

        <feMorphology in="SourceAlpha" operator="erode" radius="8" result="drop2" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 0.3 0"
        />
        <feBlend in2="dropShadow1" mode="normal" result="dropShadow2" />
        <feBlend in="SourceGraphic" in2="dropShadow2" mode="normal" result="shape" />
      </filter>
    </defs>
  </svg>
</template>
